<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-12 top">
        <router-link
          class="return"
          :to="{
            name: 'Event List'
          }"
        >
          <i class="fas fa-chevron-left"></i>
          {{ $t("events.newEvent.back") }}
        </router-link>
      </div>
      <div
        class="col-md-12 happening"
        v-if="this.$route.params.isHappeningEvent"
      >
        <span>{{ $t("events.happeningNowAlert") }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <h1 v-if="!this.$route.params.isHistory" class="black title">
          {{ $t("events.newEvent.title") }} 1/2
        </h1>
        <p class="black">{{ $t("events.newEvent.requireFields") }}</p>
        <h1 v-if="this.$route.params.isHistory" class="black title">
          {{ name }}
        </h1>
      </div>
      <div class="col-md-6 text-right">
        <!-- Boton de guardar para nuevo evento -->
        <button
          @click="sendParametersToNextView"
          class="continue-btn btn mr-5"
          v-if="isNewEvent && !this.$route.params.isNewParams"
          :disabled="
            name === '' ||
              description === '' ||
              validFromEvent === null ||
              timeFromEvent === null ||
              timeFromEvent.HH === '' ||
              timeFromEvent.mm === '' ||
              dateToEvent === null ||
              timeToEvent === null ||
              timeToEvent.HH === '' ||
              timeToEvent.mm === '' ||
              location === '' ||
              availablePlaces === 0 ||
              availablePlaces === '' ||
              validFromApp === null ||
              timeFromApp === null ||
              timeFromApp.HH === '' ||
              timeFromApp.mm === '' ||
              validToApp === null ||
              timeToApp === null ||
              timeToApp.HH === '' ||
              timeToApp.mm === '' ||
              availablePlaces % (+numberCompanionsAllowed + 1) !== 0 ||
              imageFile === null
          "
        >
          {{ $t("events.newEvent.continueBtn") }}
        </button>
        <!-- si se retorna usa este boton -->
        <button
          @click="sendParametersToNextView"
          class="continue-btn btn mr-5"
          v-if="this.$route.params.isNewParams"
          :disabled="
            name === '' ||
              description === '' ||
              validFromEvent === null ||
              timeFromEvent === null ||
              timeFromEvent === '' ||
              timeFromEvent === '' ||
              dateToEvent === null ||
              timeToEvent === null ||
              timeToEvent === '' ||
              timeToEvent === '' ||
              location === '' ||
              availablePlaces === 0 ||
              availablePlaces === '' ||
              validFromApp === null ||
              timeFromApp === null ||
              timeFromApp === '' ||
              timeFromApp === '' ||
              validToApp === null ||
              timeToApp === null ||
              timeToApp === '' ||
              timeToApp === '' ||
              imgUrl === null ||
              availablePlaces % (+numberCompanionsAllowed + 1) !== 0
          "
        >
          {{ $t("events.newEvent.continueBtn") }}
        </button>
        <!-- Boton de guardar para nuevo evento end-->

        <!-- Botones de detalles de evento -->
        <div
          class="buttons-div-details"
          v-if="isDetails || this.$route.params.isHistory"
        >
          <button
            v-if="!this.$route.params.isHistory"
            @click="changeToEditEvent"
            class="edit-btn-event btn mr-5"
          >
            {{ $t("events.editBtn") }}
          </button>
          <router-link
            class="guest-btn btn ml-auto"
            :to="{
              name: 'Show Guests',
              params: {
                id: this.$route.params.id,
                name: name,
                isHappeningEvent: this.$route.params.isHappeningEvent,
                quantity: availablePlaces,
                numberCompanionsAllowed,
                sendInvitationsTotal,
                busyPlaces,
                isHistory: this.$route.params.isHistory
              }
            }"
            >{{ $t("events.seeGuestBtn") }}</router-link
          >
          <!-- <button class="guest-btn btn ml-auto">{{$t('events.seeGuestBtn')}}</button> -->
        </div>
        <!-- Botones de detalles de evento end-->

        <!-- Botones de editar  evento -->
        <div class="buttons-div-edit" v-if="isEditEvent">
          <button
            class="edit-btn-event btn mr-5"
            @click="saveOnlyEventChanges"
            :disabled="
              name === '' ||
                description === '' ||
                validFromEvent === null ||
                timeFromEvent === null ||
                timeFromEvent.HH === '' ||
                timeFromEvent.mm === '' ||
                dateToEvent === null ||
                timeToEvent === null ||
                timeToEvent.HH === '' ||
                timeToEvent.mm === '' ||
                location === '' ||
                availablePlaces === 0 ||
                availablePlaces === '' ||
                validFromApp === null ||
                timeFromApp === null ||
                timeFromApp.HH === '' ||
                timeFromApp.mm === '' ||
                validToApp === null ||
                timeToApp === null ||
                timeToApp.HH === '' ||
                timeToApp.mm === '' ||
                numberCompanionsAllowed < originalNumberCompanionsAllowed ||
                availablePlaces % (+numberCompanionsAllowed + 1) !== 0
            "
          >
            {{ $t("events.saveChangesBtn") }}
          </button>
          <button
            v-if="!this.$route.params.isHappeningEvent"
            @click="sendParametersToNextView"
            class="guest-btn btn ml-auto"
          >
            {{ $t("events.newEvent.continueBtn") }}
          </button>
        </div>
        <!-- Botones de editar evento end-->
      </div>
    </div>

    <div class="row mt-5">
      <!-- first column -->
      <div class="col-md-6">
        <h4 class="mb-5 black">{{ $t("events.newEvent.info") }}</h4>
        <!-- Nombre del evento -->
        <label class="black" for="name"
          >1. {{ $t("events.newEvent.name") }}: (*)</label
        >
        <input
          class="mb-5"
          id="name"
          type="text"
          :placeholder="$t('events.newEvent.namePlaceholder')"
          v-model="name"
          v-if="!isDetails || isEditEvent"
          :disabled="this.$route.params.isHappeningEvent"
        />
        <p class="ml-4" v-if="isDetails">{{ name }}</p>
        <!-- Nombre del evento end-->
        <!-- Descripcion del evento -->
        <label class="black" for="desc"
          >2. {{ $t("events.newEvent.description") }}: (*)</label
        >

        <textarea
          v-if="!isDetails || isEditEvent"
          v-model="description"
          :placeholder="$t('events.newEvent.descriptionPlaceholder')"
          :disabled="this.$route.params.isHappeningEvent"
          class="mb-5 text-area-events"
          id="desc"
        ></textarea>

        <p class="ml-4 ov-wrapper" v-if="isDetails">{{ description }}</p>
        <!-- Descripcion del evento end-->
        <!-- Date Form -->
        <label class="black" for="name"
          >3. {{ $t("events.newEvent.dateHour") }}:</label
        >
        <div class="date-row">
          <div class="initDate mr-5 mt-3">
            <label class="black">
              {{ $t("events.newEvent.init") }}:
              {{ $t("events.newEvent.dateHour") }}
            </label>
            <div class="inputs-date">
              <div class="input-form">
                <label class="black"
                  >{{ $t("events.newEvent.date") }} (*)</label
                >
                <date-picker
                  v-if="!isDetails || isEditEvent"
                  v-model="validFromEvent"
                  valuetype="format"
                  :disabled="this.$route.params.isHappeningEvent"
                  :disabled-date="notBeforeToday"
                ></date-picker>
                <p v-if="isDetails">{{ parseFromEventDetails }}</p>
              </div>
              <div class="input-form">
                <label class="ml-4 black"
                  >{{ $t("events.newEvent.hour") }} (*)</label
                >
                <vue-timepicker
                  v-if="!isDetails || isEditEvent"
                  class="ml-4"
                  v-model="timeFromEvent"
                  :disabled="this.$route.params.isHappeningEvent"
                ></vue-timepicker>
                <p class="ml-4" v-if="isDetails">{{ timeFromEvent }}</p>
              </div>
            </div>
          </div>
          <div class="endDate mt-3">
            <label class="black">
              {{ $t("events.newEvent.end") }}:
              {{ $t("events.newEvent.dateHour") }}
            </label>
            <div class="inputs-date">
              <div class="input-form">
                <label class="black"
                  >{{ $t("events.newEvent.date") }} (*)</label
                >
                <date-picker
                  v-if="!isDetails || isEditEvent"
                  v-model="validToEvent"
                  valuetype="format"
                  :disabled="this.$route.params.isHappeningEvent"
                  @change="assignToApp"
                  :disabled-date="disabledBeforeTodayAndSelected"
                ></date-picker>
                <p v-if="isDetails">{{ parseToEventDetails }}</p>
              </div>
              <div class="input-form">
                <label class="ml-4 black"
                  >{{ $t("events.newEvent.hour") }} (*)</label
                >
                <vue-timepicker
                  v-if="!isDetails || isEditEvent"
                  class="ml-4"
                  v-model="timeToEvent"
                  :disabled="this.$route.params.isHappeningEvent"
                  :hour-range="fillHours"
                  :minute-range="fillMinutes"
                  @change="assignTimeToApp"
                ></vue-timepicker>
                <p class="ml-4" v-if="isDetails">{{ timeToEvent }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- Date Form end -->
        <!-- Ubicacion -->
        <label class="mt-5 black" for="location"
          >4. {{ $t("events.newEvent.ubication") }}: (*)</label
        >
        <input
          class="mb-5"
          id="location"
          type="text"
          :placeholder="$t('events.newEvent.ubicationPlaceholder')"
          v-model="location"
          v-if="!isDetails || isEditEvent"
          :disabled="this.$route.params.isHappeningEvent || busyPlaces > 0"
        />
        <p v-if="isDetails" class="ml-4">{{ location }}</p>
        <!-- Ubicacion end-->
        <!-- Lugares disponibles-->
        <div class="available-PlacesDiv">
          <div class="availablePlacesInput">
            <label class="black" for="space"
              >5. {{ $t("events.newEvent.availableSpace") }}: (*)</label
            >
            <input
              class="mb-5"
              :class="
                availablePlaces % (+numberCompanionsAllowed + 1) !== 0
                  ? 'warning-input'
                  : ''
              "
              id="space"
              type="number"
              :placeholder="$t('events.newEvent.availableSpacePlaceholder')"
              v-model.number="availablePlaces"
              v-if="!isDetails || isEditEvent"
            />
          </div>
          <p
            v-if="
              (isEditEvent || isNewEvent) &&
                availablePlaces % (+numberCompanionsAllowed + 1) !== 0
            "
          >
            {{ $t("events.newEvent.multiplesAlert") }}
            {{ +numberCompanionsAllowed + 1 }}
            <span>{{ $t("events.newEvent.example") }}</span>
            {{ suggestedNumbersDown }} o {{ suggestedNumbersUp }}
          </p>
        </div>
        <p v-if="isDetails" class="ml-4">{{ availablePlaces }}</p>
        <!-- Lugares disponibles end-->
        <label class="black"
          >6. {{ $t("events.newEvent.allowCompanions") }}:</label
        >
        <div class="switch-div mt-4">
          <div class="form-switch">
            <div class="same-line">
              <p class="mr-3 black">{{ $t("events.newEvent.no") }}</p>
              <label class="switch switch-pill switch-outline-dark-alt mr-3">
                <input
                  @click="resetCompanions"
                  type="checkbox"
                  class="switch-input"
                  v-model="companionsAllowed"
                  :disabled="isDetails || isEditEvent"
                />
                <span class="switch-slider"></span>
              </label>
              <p class="black">{{ $t("events.newEvent.yes") }}</p>
            </div>
            <div class="number-companion ml-5" v-if="companionsAllowed">
              <label for="companionNumbers"
                >{{ $t("events.newEvent.numberCompanions") }}: (*)</label
              >
              <input
                type="number"
                :class="
                  numberCompanionsAllowed < originalNumberCompanionsAllowed
                    ? 'warning-input'
                    : ''
                "
                id="companionNumbers"
                class="companionNumbers"
                v-model.number="numberCompanionsAllowed"
                :min="originalNumberCompanionsAllowed"
                v-if="!isDetails || isEditEvent"
                :disabled="this.$route.params.isHappeningEvent"
              />
              <p class="ml-3" v-if="isDetails">{{ numberCompanionsAllowed }}</p>
              <p
                class="warning-text"
                v-if="
                  isEditEvent &&
                    numberCompanionsAllowed < originalNumberCompanionsAllowed
                "
              >
                {{ $t("events.newEvent.minorValue") }}
                {{ originalNumberCompanionsAllowed }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- first column end -->

      <!-- second column -->
      <div class="col-md-6">
        <!-- Creacion de surveys -->
        <label class="black mt-5 ml-4" for="name"
          >7. {{ $t("events.newEvent.survey") }}:</label
        >
        <div
          class="instrucctions ml-5"
          v-if="validatePreconditionToCreateSurvey || surveyId === null"
        >
          <p v-if="!this.$route.params.isHappeningEvent">
            {{ $t("events.newEvent.surveyOrders") }}
          </p>
        </div>
        <div class="body-survey" v-if="validatePreconditionToCreateSurvey">
          <p class="ml-5">{{ $t("events.newEvent.surveyInst") }}</p>
          <div class="create-survey pointer" @click="openModal">
            <div class="add-square">
              <span>+</span>
            </div>
            <span>{{ $t("events.newEvent.surveyCreate") }}</span>
          </div>
        </div>
        <div class="surveyCard" v-if="surveyId !== null">
          <h3 class="bolded">
            {{ this.$route.params.name ? this.$route.params.name : nameSurvey }}
          </h3>

          <div
            :class="
              this.$route.params.isNewEvent && surveyId
                ? 'space'
                : 'content-links'
            "
          >
            <!-- Ver y editar cuando esta editando -->
            <div class="deleteIcon">
              <i
                v-if="this.$route.params.isNewEvent && surveyId"
                class="far fa-trash-alt"
                @click="openModal('delete')"
              ></i>
            </div>
            <router-link
              v-if="isNewEvent && surveyId === null"
              :to="{
                name: 'New Survey Event',
                params: {
                  id: surveyId,
                  isEditEvent,
                  isHappeningEvent: this.$route.params.isHappeningEvent,
                  eventId: this.$route.params.id,
                  surveyObj: {
                    name: nameSurvey
                  },
                  surveyType
                }
              }"
              >{{ $t("events.seeEdit") }}</router-link
            >
            <!-- Ver solo contenido en detalles -->
            <router-link
              v-if="surveyId !== null"
              :to="{
                name: 'New Survey Event',
                params: {
                  id: surveyId,
                  isDetails: true,
                  isHappeningEvent: this.$route.params.isHappeningEvent,
                  eventId: this.$route.params.id,
                  nameSurvey,
                  event: this.eventObj
                }
              }"
              >{{ $t("events.onlySee") }}</router-link
            >
          </div>
        </div>
        <!-- Uploaders form -->
        <div class="file-uploader mt-5">
          <label class="black ml-5"
            >8. {{ $t("events.newEvent.eventImage") }}: (JPG, JPEG, PNG
            *)</label
          >
          <FileUploader
            :id="'public'"
            :placeholder="$t('news.new.cover_ph')"
            :type="'image/*'"
            :validate="'image/'"
            :label="$t('news.new.browse')"
            :fileUrl="imgUrl"
            @setFile="setImageFile"
            class="imgUploader"
            :class="
              isDetails || this.$route.params.isHappeningEvent
                ? 'disable-upload'
                : ''
            "
          />
        </div>
        <div class="file-uploader mt-5">
          <label class="black ml-5"
            >9. {{ $t("events.newEvent.files") }} (PDF):</label
          >

          <FileUploader
            :placeholder="$t('menu.file_ph')"
            :type="'application/pdf'"
            :validate="'application/pdf'"
            :label="$t('menu.browse')"
            :fileUrl="fileUrl"
            @setFile="setFirstFile"
            class="imgUploader"
            :class="
              isDetails || this.$route.params.isHappeningEvent
                ? 'disable-upload'
                : ''
            "
          />
        </div>
        <div class="file-uploader">
          <FileUploader
            :id="'attachment'"
            :placeholder="$t('news.new.cover_ph')"
            :type="'application/pdf'"
            :validate="'application/pdf'"
            :label="$t('news.new.browse')"
            :fileUrl="secondFileUrl"
            @setFile="setSecondFile"
            class="imgUploader"
            :class="
              isDetails || this.$route.params.isHappeningEvent
                ? 'disable-upload'
                : ''
            "
          />
        </div>
        <!-- Uploaders form end-->
        <label class="black ml-5 mt-5"
          >10. {{ $t("events.newEvent.isConfirmObl") }}:</label
        >
        <div class="check-div">
          <label for="obl">
            <input
              type="checkbox"
              id="obl"
              v-model="confirmationRequired"
              :disabled="this.$route.params.isHappeningEvent || isDetails"
            />
            {{ $t("events.newEvent.confirmObl") }}
          </label>
        </div>
        <label class="black ml-5 mt-5"
          >11. {{ $t("events.newEvent.isShareAllowed") }}:</label
        >
        <div class="check-div">
          <label for="shareAllowed">
            <input
              type="checkbox"
              id="shareAllowed"
              v-model="sharedAllowed"
              :disabled="this.$route.params.isHappeningEvent || isDetails"
            />
            {{ $t("events.newEvent.shareAllowed") }}
          </label>
        </div>
        <!-- Date Form -->
        <label class="black mt-5 ml-4" for="name"
          >12. {{ $t("events.newEvent.validityEvent") }}:</label
        >
        <div class="date-row ml-4">
          <div class="initDate mr-5 mt-3">
            <label class="black">
              {{ $t("events.newEvent.init") }}:
              {{ $t("events.newEvent.dateHour") }}
            </label>
            <div class="inputs-date">
              <div class="input-form">
                <label class="black"
                  >{{ $t("events.newEvent.date") }} (*)</label
                >
                <date-picker
                  v-if="!isDetails || isEditEvent"
                  v-model="validFromApp"
                  valuetype="format"
                  :disabled="this.$route.params.isHappeningEvent"
                  :disabled-date="notBeforeToday"
                ></date-picker>
                <p v-if="isDetails">{{ parseFromAppDetails }}</p>
              </div>
              <div class="input-form">
                <label class="ml-4 black"
                  >{{ $t("events.newEvent.hour") }} (*)</label
                >
                <vue-timepicker
                  v-if="!isDetails || isEditEvent"
                  :disabled="this.$route.params.isHappeningEvent"
                  class="ml-4"
                  v-model="timeFromApp"
                ></vue-timepicker>
                <p class="ml-4" v-if="isDetails">{{ timeFromApp }}</p>
              </div>
            </div>
          </div>
          <div class="endDate mt-3">
            <label class="black">
              {{ $t("events.newEvent.end") }}:
              {{ $t("events.newEvent.dateHour") }}
            </label>
            <div class="inputs-date">
              <div class="input-form">
                <label class="black">{{ $t("events.newEvent.date") }}</label>
                <date-picker
                  v-if="!isDetails || isEditEvent"
                  v-model="validToApp"
                  valuetype="format"
                  :disabled="true"
                ></date-picker>
                <p v-if="isDetails">{{ parseToAppDetails }}</p>
              </div>
              <div class="input-form">
                <label class="ml-4 black">{{
                  $t("events.newEvent.hour")
                }}</label>
                <vue-timepicker
                  :disabled="true"
                  v-if="!isDetails || isEditEvent"
                  class="ml-4"
                  v-model="timeToApp"
                ></vue-timepicker>
                <p class="ml-4" v-if="isDetails">{{ timeToApp }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- Date Form end -->
      </div>
    </div>
    <Modal v-if="modalActive" @closeModal="closeModal">
      <template #header>
        <h6 class="modal-title bolded" v-if="!deleteModalSurvey">
          {{ $t("events.newEvent.modal-title") }}
        </h6>
        <h6 v-if="deleteModalSurvey" class="modal-title">
          {{ $t("surveys.modal.deleteTitle") }}
        </h6>
      </template>
      <template>
        <label v-if="!deleteModalSurvey">{{
          $t("events.newEvent.labelModal")
        }}</label>
        <input
          type="text"
          v-if="!deleteModalSurvey"
          v-model="nameSurvey"
          :placeholder="$t('events.newEvent.labelModal')"
        />
        <div v-if="deleteModalSurvey">
          <p>{{ $t("surveys.modal.deleteQuestion") }}</p>
        </div>
      </template>
      <template #footer>
        <div class="controls">
          <span class="control cancel-btn mr-4" @click="closeModal">{{
            $t("map.benefits.list.modal.cancel")
          }}</span>
          <button
            v-if="!deleteModalSurvey"
            type="control button"
            class="control entered-btn"
            :class="nameSurvey === '' ? 'disable' : ''"
            @click="createSurvey"
            :disabled="nameSurvey === ''"
          >
            {{ $t("events.newEvent.createBtn") }}
          </button>
          <button
            v-if="deleteModalSurvey"
            type="control button"
            class="control entered-btn"
            @click="deleteSurvey(surveyId)"
          >
            {{ $t("surveys.modal.deleteButton") }}
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-timepicker/dist/VueTimepicker.css";
import VueTimepicker from "vue2-timepicker";
import moment from "moment";
import S3_Handler from "@/lib/api/s3_handler";
import API_SERVICE from "@/lib/api/Events.js";
import SURVEYS_API_SERVICE from "@/lib/api/Surveys.js";

const Modal = () => import("@/components/Modal");

const api = new API_SERVICE();
const apiSurvey = new SURVEYS_API_SERVICE();

const FileUploader = () => import("@/components/FileUploader");

export default {
  components: {
    DatePicker,
    VueTimepicker,
    FileUploader,
    Modal
  },
  data() {
    return {
      file: null,
      secondFile: null,
      imageFile: null,
      fileUrl: null,
      secondFileUrl: null,
      imgUrl: null,
      name: "",
      description: "",
      validFromEvent: null,
      timeFromEvent: null,
      validToEvent: null,
      timeToEvent: null,
      location: "",
      availablePlaces: 0,
      companionsAllowed: false,
      numberCompanionsAllowed: 0,
      image: null,
      confirmationRequired: false,
      sendSurvey: false,
      validFromApp: null,
      timeFromApp: null,
      validToApp: null,
      timeToApp: null,
      attachments: [],
      internalUsers: [],
      externalUsers: [],
      isDetails: false,
      isNewEvent: false,
      isEditEvent: false,
      parseFromEventDetails: null,
      parseToEventDetails: null,
      parseFromAppDetails: null,
      parseToAppDetails: null,
      imageEvent: null,
      internalUsers: [],
      originalNumberCompanionsAllowed: 0,
      sendInvitationsTotal: 0,
      busyPlaces: 0,
      modalActive: false,
      nameSurvey: "",
      surveyId: null,
      surveyType: "multipleOptionSurvey",
      originalControlNumbers: [],
      notBefore: new Date(),
      sharedAllowed: false,
      eventObj: null,
      deleteModalSurvey: false
    };
  },
  async beforeMount() {
    if (this.$route.params.id) {
      let id = this.$route.params.id;
      await this.getEventByIdAndFilled(id);
      if (this.$route.params.id && this.$route.params.details) {
        this.isDetails = this.$route.params.details;
        this.isEditEvent = false;
        this.isNewEvent = false;
      } else if (this.$route.params.id && this.$route.params.isEdit) {
        this.isDetails = false;
        this.isEditEvent = this.$route.params.isEdit;
        this.isNewEvent = false;
      }
    } else {
      this.isNewEvent = true;
      this.surveyId = this.$route.params.surveyId || null;
    }
    if (this.$route.params.event) {
      let event = this.$route.params.event;
      this.eventObj = this.$route.params.event;
      this.name = event.name;
      this.sharedAllowed = event.sharedAllowed;
      this.description = event.description;
      this.validFromEvent = new Date(event.validFromEvent);
      this.timeFromEvent = moment(this.validFromEvent).format("HH:mm");
      this.validToEvent = new Date(event.validToEvent);
      this.timeToEvent = moment(this.validToEvent).format("HH:mm");
      this.location = event.location;
      this.availablePlaces = event.availablePlaces;
      this.companionsAllowed = event.companionsAllowed;
      this.numberCompanionsAllowed = +event.numberCompanionsAllowed;
      this.confirmationRequired = event.confirmationRequired;
      this.validFromApp = new Date(event.validFromApp);
      this.timeFromApp = moment(this.validFromApp).format("HH:mm");
      this.validToApp = new Date(event.validToApp);
      this.timeToApp = moment(this.validToApp).format("HH:mm");
      this.imgUrl = this.$route.params.event.image;
      this.imageFile = this.$route.params.event.image;
      if (this.$route.params.isNewParams) {
        if (this.$route.params.event.attachments.length > 0) {
          this.attachments = this.$route.params.event.attachments;
          this.fileUrl = this.$route.params.event.attachments[0];
          this.secondFileUrl = this.$route.params.event.attachments[1];
        }
      }
    }
  },
  computed: {
    fillHours() {
      let hours = [];
      if (this.validFromEvent && this.validToEvent) {
        if (this.validFromEvent.toString() === this.validToEvent.toString()) {
          let initHour = this.timeFromEvent ? +this.timeFromEvent.HH : 0;
          for (let index = initHour; index < 24; index++) {
            hours.push(index);
          }
          return hours;
        }
      }
      for (let index = 0; index < 24; index++) {
        hours.push(index);
      }
      return hours;
    },
    fillMinutes() {
      let minutes = [];
      if (this.validFromEvent && this.validToEvent) {
        if (this.validFromEvent.toString() === this.validToEvent.toString()) {
          if (this.timeFromEvent && this.timeToEvent) {
            if (this.timeFromEvent.HH === this.timeToEvent.HH) {
              let initMinute = this.timeFromEvent ? +this.timeFromEvent.mm : 0;
              for (let index = initMinute + 1; index < 60; index++) {
                minutes.push(index);
              }
              return minutes;
            }
          }
        }
      }
      for (let index = 0; index < 60; index++) {
        minutes.push(index);
      }
      return minutes;
    },
    validatePreconditionToCreateSurvey() {
      if (
        this.surveyId === null &&
        !this.$route.params.isHappeningEvent &&
        this.validFromEvent !== null &&
        (this.isNewEvent || this.isEditEvent) &&
        this.validToEvent !== null &&
        this.validFromApp !== null &&
        this.validToApp !== null &&
        this.timeFromEvent &&
        this.timeToEvent &&
        this.timeFromApp &&
        this.timeToApp &&
        this.timeFromEvent.HH !== "" &&
        this.timeFromEvent.mm !== "" &&
        this.timeToEvent.HH !== "" &&
        this.timeToEvent.mm !== "" &&
        this.timeFromApp.HH !== "" &&
        this.timeToApp.mm !== ""
      ) {
        return true;
      }
      return false;
    },
    suggestedNumbersDown() {
      let multiploInicial = this.numberCompanionsAllowed + 1;
      return this.availablePlaces - (this.availablePlaces % multiploInicial);
    },
    suggestedNumbersUp() {
      let multiploInicial = this.numberCompanionsAllowed + 1;
      return (
        this.availablePlaces -
        (this.availablePlaces % multiploInicial) +
        multiploInicial
      );
    }
  },
  methods: {
    deleteSurvey: async function(id) {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await apiSurvey.inactiveSurvey(id);
        delete this.$route.params.surveyId;
        this.surveyId = null;
        this.closeModal();
        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    notBeforeToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    },
    disabledBeforeTodayAndSelected(date) {
      const today = new Date();
      const notBeforeSelected = new Date(this.validFromEvent);
      today.setHours(0, 0, 0, 0);
      notBeforeSelected.setHours(0, 0, 0, 0);
      return date < today || date < notBeforeSelected;
    },
    assignToApp() {
      this.validToApp = this.validToEvent;
    },
    assignTimeToApp() {
      this.timeToApp = this.timeToEvent;
    },
    changeToEditEvent() {
      this.$router.push({
        name: "Edit Event",
        id: this.$route.params.id,
        params: {
          isHappeningEvent: this.$route.params.isHappeningEvent,
          isEdit: true
        }
      });
      this.isDetails = false;
      this.isEditEvent = true;
    },
    openModal: function(value) {
      if (value === "delete") {
        this.deleteModalSurvey = true;
      } else {
        this.deleteModalSurvey = false;
      }
      this.modalActive = true;
    },
    closeModal: function() {
      this.modalActive = false;
      this.deleteModalSurvey = false;
    },
    setImageFile: function(file) {
      this.imageFile = file;
    },
    setFirstFile: function(file) {
      this.file = file;
    },
    setSecondFile: function(file) {
      this.secondFile = file;
    },
    async sendParametersToNextView() {
      let isEdit = this.$route.params.isEdit;
      let hourFromEvent = null;
      let minFromEvent = null;
      let dateFromEvent = null;

      let hourToEvent = null;
      let minToEvent = null;
      let dateToEvent = null;
      let hourFromApp = null;
      let minFromApp = null;
      let dateFromApp = null;

      let hourToApp = null;
      let minToApp = null;
      let dateToApp = null;
      if (isEdit) {
        //Si es editar toma las fechas asi
        hourFromEvent = this.timeFromEvent.split(":")[0];
        minFromEvent = this.timeFromEvent.split(":")[1];
        dateFromEvent = new Date(this.validFromEvent);
        dateFromEvent.setHours(hourFromEvent, minFromEvent, 0);

        hourToEvent = this.timeToEvent.split(":")[0];
        minToEvent = this.timeToEvent.split(":")[1];
        dateToEvent = new Date(this.validToEvent);
        dateToEvent.setHours(hourToEvent, minToEvent, 0);
        //apps dates
        hourFromApp = this.timeFromApp.split(":")[0];
        minFromApp = this.timeFromApp.split(":")[1];
        dateFromApp = new Date(this.validFromApp);
        dateFromApp.setHours(hourFromApp, minFromApp, 0);

        hourToApp = this.timeToApp.split(":")[0];
        minToApp = this.timeToApp.split(":")[1];
        dateToApp = new Date(this.validToApp);
        dateToApp.setHours(hourToApp, minToApp, 0);
      } else {
        if (this.surveyId !== null || this.$route.params.isNewParams) {
          hourFromEvent = this.timeFromEvent.split(":")[0];
          minFromEvent = this.timeFromEvent.split(":")[1];
          dateFromEvent = new Date(this.validFromEvent);
          dateFromEvent.setHours(hourFromEvent, minFromEvent, 0);

          hourToEvent = this.timeToEvent.split(":")[0];
          minToEvent = this.timeToEvent.split(":")[1];
          dateToEvent = new Date(this.validToEvent);
          dateToEvent.setHours(hourToEvent, minToEvent, 0);
          //apps dates
          hourFromApp = this.timeFromApp.split(":")[0];
          minFromApp = this.timeFromApp.split(":")[1];
          dateFromApp = new Date(this.validFromApp);
          dateFromApp.setHours(hourFromApp, minFromApp, 0);

          hourToApp = this.timeToApp.split(":")[0];
          minToApp = this.timeToApp.split(":")[1];
          dateToApp = new Date(this.validToApp);
          dateToApp.setHours(hourToApp, minToApp, 0);
        } else {
          //si es crear las toma asi
          hourFromEvent = this.timeFromEvent.HH;
          minFromEvent = this.timeFromEvent.mm;
          dateFromEvent = new Date(this.validFromEvent);
          dateFromEvent.setHours(hourFromEvent, minFromEvent, 0);

          hourToEvent = this.timeToEvent.HH;
          minToEvent = this.timeToEvent.mm;
          dateToEvent = new Date(this.validToEvent);
          dateToEvent.setHours(hourToEvent, minToEvent, 0);
          //apps dates
          hourFromApp = this.timeFromApp.HH;
          minFromApp = this.timeFromApp.mm;
          dateFromApp = new Date(this.validFromApp);
          dateFromApp.setHours(hourFromApp, minFromApp, 0);

          hourToApp = this.timeToApp.HH;
          minToApp = this.timeToApp.mm;
          dateToApp = new Date(this.validToApp);
          dateToApp.setHours(hourToApp, minToApp, 0);
        }
      }
      if (this.$route.params.isNewParams) {
        this.imgUrl = this.$route.params.event.image;
        if (this.$route.params.event.attachments.length > 0) {
          this.attachments = this.$route.params.event.attachments;
          this.fileUrl = this.$route.params.event.attachments[0];
          this.secondFileUrl = this.$route.params.event.attachments[1];
        }
      } else {
        await this.uploadFile();
      }
      //Construccion del obejto a mandar
      let event = {
        name: this.name,
        description: this.description,
        validFromEvent: dateFromEvent,
        validToEvent: dateToEvent,
        location: this.location,
        availablePlaces: +this.availablePlaces,
        companionsAllowed: this.companionsAllowed,
        numberCompanionsAllowed: +this.numberCompanionsAllowed,
        image: isEdit ? this.imgUrl : this.imageEvent,
        confirmationRequired: this.confirmationRequired,
        sendSurvey: this.surveyId === null ? false : true,
        validFromApp: dateFromApp,
        validToApp: dateToApp,
        attachments: this.attachments,
        sendInvitationsTotal: this.sendInvitationsTotal,
        availablePlacesQuantity: this.availablePlaces - this.busyPlaces,
        busyPlaces: this.busyPlaces,
        surveyId: this.$route.params.surveyId,
        sharedAllowed: this.sharedAllowed,
        orginalInternalUsers: this.internalUsers
      };
      if (isEdit) {
        event.internalUsers = this.internalUsers;
        event.orginalInternalUsers = this.internalUsers;
        event.originalControlNumbers = this.originalControlNumbers;
        event.surveyId = this.surveyId;
      }
      if (this.$route.params.isNewParams) {
        event.image = this.imgUrl;
        event.attachments = this.attachments;
      }
      this.$router.push({
        name: "Guests Selection",
        params: {
          event: event,
          eventId: this.$route.params.id
        }
      });
    },
    async saveOnlyEventChanges() {
      let isEdit = this.$route.params.isEdit;
      let hourFromEvent = null;
      let minFromEvent = null;
      let dateFromEvent = null;

      let hourToEvent = null;
      let minToEvent = null;
      let dateToEvent = null;
      let hourFromApp = null;
      let minFromApp = null;
      let dateFromApp = null;

      let hourToApp = null;
      let minToApp = null;
      let dateToApp = null;
      if (isEdit) {
        //Si es editar toma las fechas asi
        hourFromEvent = this.timeFromEvent.split(":")[0];
        minFromEvent = this.timeFromEvent.split(":")[1];
        dateFromEvent = new Date(this.validFromEvent);
        dateFromEvent.setHours(hourFromEvent, minFromEvent, 0);

        hourToEvent = this.timeToEvent.split(":")[0];
        minToEvent = this.timeToEvent.split(":")[1];
        dateToEvent = new Date(this.validToEvent);
        dateToEvent.setHours(hourToEvent, minToEvent, 0);
        //apps dates
        hourFromApp = this.timeFromApp.split(":")[0];
        minFromApp = this.timeFromApp.split(":")[1];
        dateFromApp = new Date(this.validFromApp);
        dateFromApp.setHours(hourFromApp, minFromApp, 0);

        hourToApp = this.timeToApp.split(":")[0];
        minToApp = this.timeToApp.split(":")[1];
        dateToApp = new Date(this.validToApp);
        dateToApp.setHours(hourToApp, minToApp, 0);
      } else {
        //si es crear las toma asi
        hourFromEvent = this.timeFromEvent.HH;
        minFromEvent = this.timeFromEvent.mm;
        dateFromEvent = new Date(this.validFromEvent);
        dateFromEvent.setHours(hourFromEvent, minFromEvent, 0);

        hourToEvent = this.timeToEvent.HH;
        minToEvent = this.timeToEvent.mm;
        dateToEvent = new Date(this.validToEvent);
        dateToEvent.setHours(hourToEvent, minToEvent, 0);
        //apps dates
        hourFromApp = this.timeFromApp.HH;
        minFromApp = this.timeFromApp.mm;
        dateFromApp = new Date(this.validFromApp);
        dateFromApp.setHours(hourFromApp, minFromApp, 0);

        hourToApp = this.timeToApp.HH;
        minToApp = this.timeToApp.mm;
        dateToApp = new Date(this.validToApp);
        dateToApp.setHours(hourToApp, minToApp, 0);
      }

      // Parseo de las fechas para la app

      //Construccion del obejto a mandar
      await this.uploadFile();
      let dataToEdit = {
        name: this.name,
        description: this.description,
        validFromEvent: dateFromEvent,
        validToEvent: dateToEvent,
        location: this.location,
        sharedAllowed: this.sharedAllowed,
        availablePlaces: +this.availablePlaces,
        companionsAllowed: this.companionsAllowed,
        numberCompanionsAllowed: +this.numberCompanionsAllowed,
        image: this.imageEvent,
        confirmationRequired: this.confirmationRequired,
        sendSurvey: this.surveyId === null ? false : true,
        validFromApp: dateFromApp,
        validToApp: dateToApp,
        attachments: this.attachments,
        surveyId: this.surveyId === null ? null : this.surveyId
      };

      let id = this.$route.params.id;
      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.editEvent(dataToEdit, id);
        if (this.surveyId !== null) {
          const assign = api.assignUsersToSurvey({
            id: this.surveyId,
            assignedUsers: this.originalControlNumbers
          });
        }
        this.$router.push({ name: "Event List" });
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    resetCompanions() {
      this.numberCompanionsAllowed = 0;
    },
    uploadFile: async function() {
      try {
        //Subida de archivos
        const s3 = new S3_Handler();
        const timestamp = Date.now();
        // Asignando a los attachments y imagenes
        if (this.imageFile !== null) {
          const fileImage = await s3.uploadFile(
            `${timestamp}image_${this.imageFile.name}`,
            this.imageFile
          );
          this.imageEvent = fileImage.Location;
        }
        if (this.file !== null) {
          const file1 = await s3.uploadFile(
            `${this.file.name}`,
            this.file
          );
          this.attachments[0] = file1.Location;
        }
        if (this.secondFile !== null) {
          const file2 = await s3.uploadFile(
            `${this.secondFile.name}`,
            this.secondFile
          );
          if (this.attachments.length > 0) {
            this.attachments[1] = file2.Location;
          } else {
            this.attachments.push(file2.Location);
          }
        }
      } catch (error) {
        console.log(error);

        throw error;
      }
    },
    async getEventByIdAndFilled(id) {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const eventInfo = await api.getEventById(id);
        let fillEvent = eventInfo.event[0];

        //Rellenar evento
        this.name = fillEvent.name;
        this.description = fillEvent.description;
        this.sharedAllowed = fillEvent.sharedAllowed;
        //Parseo de fechas del evento
        let parseFromEvent = new Date(fillEvent.validFromEvent);
        let parseTimeFromEvent = moment(parseFromEvent).format("HH:mm");
        this.validFromEvent = parseFromEvent;
        this.timeFromEvent = parseTimeFromEvent;
        let parseToEvent = new Date(fillEvent.validToEvent);
        let parseTimeToEvent = moment(parseToEvent).format("HH:mm");
        this.validToEvent = parseToEvent;
        this.timeToEvent = parseTimeToEvent;
        this.parseFromEventDetails = moment(parseFromEvent).format(
          "DD/MM/YYYY"
        );
        this.parseToEventDetails = moment(parseToEvent).format("DD/MM/YYYY");
        //Parseo de fechas de las apps
        let parseFromApp = new Date(fillEvent.validFromApp);
        let parseTimeFromApp = moment(parseFromApp).format("HH:mm");
        this.validFromApp = parseFromApp;
        this.timeFromApp = parseTimeFromApp;
        let parseToApp = new Date(fillEvent.validToApp);
        let parseTimeToApp = moment(parseToApp).format("HH:mm");
        this.validToApp = parseToApp;
        this.timeToApp = parseTimeToApp;

        this.parseFromAppDetails = moment(parseFromApp).format("DD/MM/YYYY");
        this.parseToAppDetails = moment(parseToApp).format("DD/MM/YYYY");
        //Termina parseo continua llenado de información
        this.location = fillEvent.location;
        this.availablePlaces = fillEvent.availablePlaces;
        this.companionsAllowed = fillEvent.companionsAllowed;
        this.numberCompanionsAllowed =
          fillEvent.numberCompanionsAllowed === null
            ? 0
            : fillEvent.numberCompanionsAllowed;
        this.originalNumberCompanionsAllowed = this.numberCompanionsAllowed;
        //Aqui va el llenado de archivos
        this.imgUrl = fillEvent.image ? fillEvent.image : null;

        this.fileUrl =
          fillEvent.attachments.length > 0
            ? fillEvent.attachments[0].url
            : null;
        this.secondFileUrl =
          fillEvent.attachments.length > 1
            ? fillEvent.attachments[1].url
            : null;
        if (this.fileUrl) {
          this.attachments.push(this.fileUrl);
        }
        if (this.secondFileUrl) {
          this.attachments.push(this.secondFileUrl);
        }
        //Continua llenado
        this.confirmationRequired = fillEvent.confirmationRequired;
        //Llenado de los usuarios internos
        this.internalUsers = fillEvent.internalUsers;
        this.originalControlNumbers = fillEvent.controlNumbers;
        this.sendInvitationsTotal = fillEvent.total;
        this.busyPlaces = fillEvent.busyPlaces;
        //Aqui va el llenado de encuestas (pendiente)
        this.nameSurvey = fillEvent.surveyName;
        if (fillEvent.surveyId === null) {
          this.surveyId = null;
        } else {
          this.surveyId = fillEvent.surveyId;
        }
        if (this.$route.params.surveyId) {
          this.surveyId = this.$route.params.surveyId;
        }
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    createSurvey: async function() {
      let dateFrom = new Date();
      dateFrom.setHours(dateFrom.getHours() - 6);
      let dateTo = new Date();
      dateTo.setHours(dateTo.getHours() - 6);

      this.$store.commit("global/SET_LOADING", true);
      try {
        let params = {
          name: this.nameSurvey,
          details: "-",
          valid_from: dateFrom,
          valid_to: dateTo,
          survey_type: false,
          isEvent: true
        };
        const resp = await apiSurvey.createSurvey(params);
        await this.uploadFile();
        if (resp && resp.survey) {
          this.closeModal();
          this.$store.commit("global/SET_LOADING", false);
          let isEdit = this.$route.params.isEdit;
          let hourFromEvent = null;
          let minFromEvent = null;
          let dateFromEvent = null;

          let hourToEvent = null;
          let minToEvent = null;
          let dateToEvent = null;
          let hourFromApp = null;
          let minFromApp = null;
          let dateFromApp = null;

          let hourToApp = null;
          let minToApp = null;
          let dateToApp = null;
          if (isEdit) {
            //Si es editar toma las fechas asi
            hourFromEvent = this.timeFromEvent.split(":")[0];
            minFromEvent = this.timeFromEvent.split(":")[1];
            dateFromEvent = new Date(this.validFromEvent);
            dateFromEvent.setHours(hourFromEvent, minFromEvent, 0);

            hourToEvent = this.timeToEvent.split(":")[0];
            minToEvent = this.timeToEvent.split(":")[1];
            dateToEvent = new Date(this.validToEvent);
            dateToEvent.setHours(hourToEvent, minToEvent, 0);
            //apps dates
            hourFromApp = this.timeFromApp.split(":")[0];
            minFromApp = this.timeFromApp.split(":")[1];
            dateFromApp = new Date(this.validFromApp);
            dateFromApp.setHours(hourFromApp, minFromApp, 0);

            hourToApp = this.timeToApp.split(":")[0];
            minToApp = this.timeToApp.split(":")[1];
            dateToApp = new Date(this.validToApp);
            dateToApp.setHours(hourToApp, minToApp, 0);
          } else {
            //si es crear las toma asi

            hourFromEvent = this.timeFromEvent.HH;
            minFromEvent = this.timeFromEvent.mm;
            dateFromEvent = new Date(this.validFromEvent);
            dateFromEvent.setHours(hourFromEvent, minFromEvent, 0);

            hourToEvent = this.timeToEvent.HH;
            minToEvent = this.timeToEvent.mm;
            dateToEvent = new Date(this.validToEvent);
            dateToEvent.setHours(hourToEvent, minToEvent, 0);
            //apps dates
            hourFromApp = this.timeFromApp.HH;
            minFromApp = this.timeFromApp.mm;
            dateFromApp = new Date(this.validFromApp);
            dateFromApp.setHours(hourFromApp, minFromApp, 0);

            hourToApp = this.timeToApp.HH;
            minToApp = this.timeToApp.mm;
            dateToApp = new Date(this.validToApp);
            dateToApp.setHours(hourToApp, minToApp, 0);
          }

          let event = {
            name: this.name,
            description: this.description,
            validFromEvent: dateFromEvent,
            validToEvent: dateToEvent,
            location: this.location,
            availablePlaces: +this.availablePlaces,
            companionsAllowed: this.companionsAllowed,
            numberCompanionsAllowed: +this.numberCompanionsAllowed,
            confirmationRequired: this.confirmationRequired,
            sharedAllowed: this.sharedAllowed,
            image: this.imageEvent,
            validFromApp: dateFromApp,
            validToApp: dateToApp
          };
          const id = resp.survey.id;
          const surveyType = resp.survey.survey_type;
          let surveyObj = resp.survey;
          surveyObj.validFrom = surveyObj.valid_from;
          surveyObj.validTo = surveyObj.valid_to;
          let type = "multipleOptionSurvey";
          surveyObj.surveyType = type;
          surveyObj.eventDateFrom = this.validFromEvent;
          if (isEdit) {
            this.$router.push({
              name: "New Survey Event",
              params: {
                id,
                surveyType: type,
                surveyObj,
                edit: true,
                eventId: this.$route.params.id
              }
            });
          } else {
            this.$router.push({
              name: "New Survey Event",
              params: { id, surveyType: type, surveyObj, create: true, event }
            });
          }
        }
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    }
  }
};
</script>

<style>
.date-row {
  width: 100%;
  display: flex;
}
.date-row .initDate .inputs-date {
  display: flex;
}
.date-row .initDate .inputs-date .input-form {
  display: flex;
  flex-direction: column;
}
.date-row .endDate .inputs-date {
  display: flex;
}
.date-row .endDate .inputs-date .input-form {
  display: flex;
  flex-direction: column;
}
.switch-div {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.switch-div .form-switch {
  display: flex;
  width: 100%;
}
.switch-div .form-switch .same-line {
  display: flex;
  width: 14%;
}
.black {
  color: black;
  font-weight: bold;
}
.companionNumbers {
  width: 60% !important;
}
.file-uploader {
  display: flex;
  flex-direction: column;
}
.file-uploader .imgUploader {
  width: 50% !important;
  margin-left: 3rem;
}
.check-div {
  margin-left: 4rem;
  margin-top: 0.6rem;
}
.create-survey {
  display: flex;
  margin-left: 4rem;
  margin-top: 0.3rem;
  align-items: center;
  width: 30%;
}
.create-survey .add-square {
  display: flex;
  width: 40px;
  height: 40px;
  font-size: 1.6rem;
  font-weight: bold;
  color: #fff;
  background: #333333;
  justify-content: center;
  align-items: center;
  margin-right: 1rem;
}
.switch-slider {
  width: 40px !important;
}
.continue-btn {
  background: black !important;
  border-radius: 0px !important;
  color: #fff !important;
  padding: 0.8rem !important;
  margin-left: auto !important;
}
.edit-btn-event {
  background: transparent !important;
  border-radius: 0px !important;
  color: #000 !important;
  border: 1px solid #000 !important;
  padding: 0.6rem 1rem !important;
  margin-left: auto !important;
}
.guest-btn {
  background: black !important;
  border-radius: 0px !important;
  color: #fff !important;
  padding: 0.6rem 1rem !important;
  margin-left: auto !important;
}
.continue-btn:hover,
.guest-btn:hover {
  color: #fff;
}
.title {
  margin-left: -1rem;
}
.return {
  color: black;
  cursor: pointer;
}
.return:hover {
  text-decoration: underline !important;
}
.happening {
  background: #bb0a30;
  color: #fff;
  text-align: center;
  border-radius: 0px;
  font-weight: bold;
  padding: 1rem;
  margin-top: 0.5rem;
}
.warning-input {
  border-color: #bb0a30 !important;
}
.available-PlacesDiv {
  width: 100%;
  display: flex;
  align-items: center;
}
.available-PlacesDiv p {
  width: 80%;
  color: #bb0a30;
  font-weight: 500;
}
.available-PlacesDiv .availablePlacesInput {
  display: flex;
  flex-direction: column;
  margin-right: 1rem;
}
.warning-text {
  color: #bb0a30;
}
.disable-upload {
  pointer-events: none !important;
}
.surveyCard {
  width: 80%;
  margin-left: 1rem;
  padding: 1rem;
  background: #fff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
}
.surveyCard .content-links {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.surveyCard .space {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.surveyCard .space .deleteIcon > i {
  font-size: 16px;
  cursor: pointer;
}
.surveyCard .icons-div {
  font-size: 1rem;
  color: #333;
  cursor: pointer;
}
.surveyCard a {
  font-size: 1rem;
  color: #333;
}
.pointer {
  cursor: pointer;
}
.controls {
  display: flex;
  justify-content: end;
  align-items: flex-end;
}
.controls .cancel-btn,
.controls .entered-btn {
  cursor: pointer;
}
.controls .entered-btn {
  background: #000 !important;
  color: #fff !important;
  padding: 0.5rem;
}
.controls .disable {
  background: rgba(0, 0, 0, 0.5) !important;
}
.controls .cancel-btn {
  padding: 0.5rem;
}
.text-area-events {
  width: 100%;
  min-height: 100px;
  max-height: 150px;
}
.ov-wrapper {
  overflow-wrap: break-word;
}
</style>
<style>
@media (min-width: 768px) and (max-width: 1700px) {
  .date-row {
    flex-wrap: wrap;
  }
}
</style>
